<template>
  <div>
    <pt-sub-title title="解读详情"></pt-sub-title>
    <div :class="$style['specification-table-div']" class="page-background" v-if="formValue.workflowStatus === 'INTERPRETED' && formValue.unscrambleDetail.userLogin">
      <table :class="$style['specification-table']">
        <th>
          <td>解读人</td>
          <td>解读时间</td>
          <td>问答内容</td>
          <td>操作</td>
        </th>
        <tr>
          <td>{{formValue.unscrambleDetail.userName}}</td>
          <td>{{formValue.unscrambleDetail.unscrambleDate}}</td>
          <td>{{formValue.unscrambleDetail.content}}</td>
          <td>--</td>
        </tr>
      </table>
    </div>
    <table :class="$style['sign-notes-detail']">
      <pt-form-list-item label="输入解读详情：" v-if="formValue.workflowStatus !== 'INTERPRETED'" :required="true">
            <wt-input placeholder="请输入解读内容....（最多不超过200个字）" type="textarea" rows='4' :max-length="200" :autosize="{ minRows: 4, maxRows: 5}"
            :class="$style['input-style']"   v-model="formValue.content" data-vv-as="解读详情" name="name"  v-validate="'required'"></wt-input>
      </pt-form-list-item>
      <pt-form-list-item v-if="formValue.workflowStatus === 'INTERPRETED'" label="输入追加解读详情：" :required="true">
            <wt-input  placeholder="请输入解读内容....（最多不超过300个字）" type="textarea" rows='4' :max-length="300" :autosize="{ minRows: 4, maxRows: 5}"
            :class="$style['input-style']"   v-model="formValue.content" data-vv-as="解读详情" name="name"  v-validate="'required'"></wt-input>
      </pt-form-list-item>
    </table>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
export default {
  name: 'report-read-detail',
  mixins: [formMixins],
  props: {
    notesDetail: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    notesDetail: {
      handler: function (val) {
        if (val.workflowStatus === 'INTERPRETED') {
          this.formValue = {
            ...val,
            content: val.additionalUnscrambleDetail[0] && val.additionalUnscrambleDetail[0].content
          }
        } else {
          this.formValue = {
            ...val,
            content: val.unscrambleDetail && val.unscrambleDetail.content
          }
        }
      }
    }
  },
  data () {
    return {
      formValue: {}
    }
  }
}
</script>

<style module lang="less">
.sign-notes-detail{
   padding: 0 20px;
}
.specification-table-div{
    margin: 20px 0;
    padding: 10px 20px 30px;
  }
.specification-table{
    display: table!important;
    width: 100%;
    border-collapse:collapse!important;
    th,tr{
        width: 100%!important;
        max-width: 100%!important;
        display: table-row!important;
        padding: 0!important;
        list-style-type:none;
        justify-content:center!important;
        border-bottom: 1px solid #C6C9D3;
        color: #5B5B5B!important;
    }
    th td{
      color: #edbe81!important;
    }
    td{
        color: #5B5B5B!important;
        text-align: left;
        justify-content:flex-start!important;
        padding: 10px;
    }
  }
</style>
